<template>
  <div class="card role">
      <div class="card-header bg-transparent">
        <div class="row align-items-center">
            <div class="col-md-6">
              <h3>Traders</h3>
            </div>
            <div class="col violetb">
              <i class="fas fa-user-tie"></i>
              <span>{{tweened.toFixed(0)}}</span>
            </div>
            <div class="text-right" v-if="isAdmin || isEditor">
              <a @click="navigateListPage()" class="moreinfo cursor-pointer"><i class="fas fa-chevron-circle-right"></i></a>
            </div>
        </div>
      </div>
  </div>
</template>
<script>
import config from "@/config";
import authService from "@/authService";
import gsap from 'gsap'

export default {
  name: "tradersWidget",
  data() {
    return {
      traderCount : 0,
      tweened: 0,
      isAdmin: false,
      isTrader : false,
      isEditor : false
    };
  },
  watch: {
    traderCount(n) {
      gsap.to(this, { duration: 0.5, tweened: Number(n) || 0 })
    }
  },
  methods: {
     navigateListPage(){
      window.location.href = "/ims/ims-traders";
    },
    getTradersCount(){
      this.loading = true;
      const auth = {
          headers: { 'org-token' : authService.getOrgToken() }
      };
      this.$http
      .get(
        config.baseUrlBidSide +
          "/group/list",
          auth
      )
      .then(result => {
        let self = this;
        result.data.forEach(element => {
          if(element.groupName.includes('Trader')){
            self.traderCount = element.userCount ? element.userCount : 0;
          }
        });
        
        this.loading = false;
      })

    },
  },
  mounted() {
    this.getTradersCount();
    this.$cognitoAuth.getUserGroup((err, role) => {
      if (err) {
        console.log("accessToken is not found", err);
      } else {
        //console.log(role)
        this.tenantName = role[0].split("-")[0];
        var roleArray = role.map(item => {
          return  item.split("-")[1];
        })
        roleArray.includes('Admin')   ? this.isAdmin  = true : this.isAdmin  = false;
        roleArray.includes('Trader')  ? this.isTrader = true : this.isTrader = false;
        roleArray.includes('Editor')  ? this.isEditor = true : this.isEditor = false;
        //this.getOfferStatus();

      }
      //console.log("isa",this.isAdmin);
    });

  }
};
</script>